const Lock = ({ color, type }) => {
  const regular = (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C5.243 0 3 2.243 3 5V7H2C0.897 7 0 7.897 0 9V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V9C16 7.897 15.103 7 14 7H13V5C13 2.243 10.757 0 8 0ZM5 5C5 3.346 6.346 2 8 2C9.654 2 11 3.346 11 5V7H5V5ZM14.002 18H9V15.722C9.595 15.375 10 14.737 10 14C10 12.897 9.103 12 8 12C6.897 12 6 12.897 6 14C6 14.736 6.405 15.375 7 15.722V18H2V9H14L14.002 18V18Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Lock;
